import {
  makeResetStyles, shorthands,
} from '@fluentui/react-components';

export const useGenerateImagePageStyles = makeResetStyles({
  display: 'flex',
  width: '100%',
  height: '100%',
  '& .prompt-panel': {
    width: 'calc((100% - 69px)/2)',
    paddingTop: '56px',
    paddingLeft: '44px',
    paddingRight: '44px',
    position: 'fixed',
    overflowY: 'auto',
    '& .title': {
      display: 'flex',
      alignItems: 'center',
      '& span': {
        color: '#171A1F',
      },
    },
    '& .remainingText': {
      marginTop: '4px',
      color: '#605e5c',
      marginBottom: '24px',
    },
    '& .prompt-section': {
      position: 'relative',
    },
    '& .message-bar': {
      display: 'flex',
      flexDirection: 'column',
      ...shorthands.gap('8px'),
      marginTop: '24px',
      width: '100%',
    },
    '& .action-bar': {
      display: 'flex',
      marginTop: '25px',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: '12px',
      '& button': {
        minWidth: 'unset',
        whiteSpace: 'nowrap',
      },
      '& .generate-button': {
        '& span': {
          color: '#FFFFFF',
        },
        '& .sparkle-icon': {
          fontSize: '24px',
          height: '24px',
          width: '24px',
        },
        backgroundImage: 'linear-gradient(91deg, #185ABD 0%, #8763C2 100%)',
      },
    },
  },
  '& .image-panel': {
    marginLeft: 'calc((100vw - (100vw - 100%)) / 2 + (100vw - 69px - 100%) / 2)',
    width: '50%',
    paddingTop: '48px',
    paddingBottom: '48px',
    backgroundColor: '#FAFAFA',
    paddingLeft: '36px',
    paddingRight: '36px',
    '& .loading-view': {
      width: '100%',
      height: '100%',
    },
  },
});
